{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "definitions": {
    "text": {
      "type": "string",
      "title": "Text",
      "description": "Represents a text value."
    },
    "number": {
      "type": "number",
      "title": "Number",
      "description": "Represents a numeric value."
    },
    "boolean": {
      "type": "boolean",
      "title": "Checkbox",
      "description": "Represents a boolean value."
    }
  }
}
